import { c as _c } from "react/compiler-runtime";
import { Table } from "@opensea/ui-kit";
import { ReceiptDisplay } from "./ReceiptDisplay";
import { ReceiptRowDisplaySkeleton } from "./ReceiptRowDisplaySkeleton";
import { ReceiptTotalDisplaySkeleton } from "./ReceiptTotalDisplaySkeleton";
export const ReceiptDisplaySkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Table itemKey={_temp} items={[{
      key: "1"
    }]} renderRow={_temp2} size="xl" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const receipt = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const receiptTotal = <Table itemKey={_temp3} items={[{}]} renderRow={_temp4} />;
    t1 = <ReceiptDisplay receipt={receipt} receiptTotal={receiptTotal} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(item) {
  return item?.key;
}
function _temp2() {
  return <ReceiptRowDisplaySkeleton />;
}
function _temp3(_, index) {
  return index;
}
function _temp4() {
  return <ReceiptTotalDisplaySkeleton />;
}